/**
 * Site-task marquee: бесшовная прокрутка без “пустоты”.
 * CSS-анимация на -50% ломается, когда ширина половин не совпадает (шрифты/кернинг/viewport).
 * Здесь измеряем ширину первого ряда и прокручиваем ровно на неё.
 */
export function initSiteTaskMarquee() {
  const root = document.querySelector('.site-task-marquee')
  if (!root) return

  const track = root.querySelector('.site-task-marquee__track')
  const firstList = root.querySelector('.site-task-marquee__list')
  if (!(track instanceof HTMLElement) || !(firstList instanceof HTMLElement)) return

  const apply = () => {
    // scrollWidth учитывает фактическую ширину контента (включая padding-end)
    const w = Math.ceil(firstList.scrollWidth)
    if (w > 0) {
      track.style.setProperty('--marquee-shift', `${w}px`)
    }
  }

  apply()

  // Подхватываем изменения ширины (резайз/шрифты/зум)
  const ro = new ResizeObserver(() => apply())
  ro.observe(firstList)
  window.addEventListener('resize', apply, { passive: true })
}

